import React from 'react';
import { Col, ListGroupItem, Row } from 'reactstrap';

export const CalendarNotify = ({ data, type, index, onClientRedirect,removeNotificationAndClose }) => {

    const onNotificationClick = (e, data) => {
        e.preventDefault();
        if (data.contractId !== '00000000-0000-0000-0000-000000000000') {
            onClientRedirect(data.contractId, index, data, type);
        }
    }

    const onCloseHanlder = (e) => {
        e.preventDefault();
        removeNotificationAndClose(index,true);
    }

    return <ListGroupItem key={index}
        className="list-group-item-action">
        <Row className="align-items-center">
            <Col md="11" className="pr-1">
                <a className="list-group-item-action" href="#item"  onClick={e => onNotificationClick(e, data)}>
                {data.contractId === '00000000-0000-0000-0000-000000000000' &&
                  <p className="text-sm mb-0"> You scheduled a meeting to start right now: <span className="h5">{data.title}</span>&nbsp;(<span>{data.message}</span>).</p>
                }

                {data.contractId !== '00000000-0000-0000-0000-000000000000' &&
                    <p className="text-sm mb-0">You scheduled a meeting to start right now: <span className="h5">{data.title}</span>&nbsp;(<span>{data.message}</span>). Click to go to the client details.</p>
                }
                </a>
               
            </Col>
            <Col md="1" className="pl-0">
                <a href="#delelte" onClick={ e=> onCloseHanlder(e)}>
                <i className="ni ni-fat-remove"></i>
                </a>
            </Col>
        </Row>
    </ListGroupItem>;
};